/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller('signInCtrl', ['$scope', '$routeParams', '$window', '$filter', 'DebugHelper', 'V3ModelHelper', 'V3SessionResource', 'UserManager', function($scope, $routeParams, $window, $filter, DebugHelper, V3ModelHelper, V3SessionResource, UserManager) {
  DebugHelper.register("signInCtrl", $scope);

  _.assignIn($scope, {
    params: {},
    routes: Packs.iKnowRoutes,
    stateUI: {
      showEmailError: false,
      showPasswordError: false,
      showMFA: false
    },

    submitForm(form) {
      form.submitted = true;
      if (!form.$valid) { return; }

      $scope.stateUI.showEmailError = false;
      $scope.stateUI.showPasswordError = false;

      return V3SessionResource.create($scope.params
      , success => $window.location.href = signinSuccessURL()
      , function(error) {
          switch (error.data.errors[0].code) {
            case "login-error-user-authentication-no-account-error":
              return $scope.stateUI.showEmailError = true;
            case "login-error-user-authentication-mfa-required-error":
              $scope.stateUI.showMFA = true;
              return $scope.stateUI.error = V3ModelHelper.humanizeV3Error(error.data);
            default:
              $scope.stateUI.showPasswordError = true;
              return $scope.stateUI.error = V3ModelHelper.humanizeV3Error(error.data);
          }
      });
    }
  }
  );

  $scope.$on('$routeChangeSuccess', ($event, current, previous) => $scope.stateUI.error = $routeParams.error);

  UserManager.loadUser().then(function(user) {
    if (user.id) {
      return $window.location.href = Packs.iKnowRoutes.v3_dashboard_path();
    }
  });

  var signinSuccessURL = function() {
    const path = $routeParams.signInSuccessPath || Packs.iKnowRoutes.v3_dashboard_path();
    return window.location.origin + path; // Include origin so that someone can't make us redirect to a different website
  };
  
  return document.title = $filter("translate")("js.registrations.signin.title") + " | Cerego";
}
]);
